import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {CardModule} from '../../../../../core/component/card/card.module';
import {LoadingModule} from '../../../../../../components/common/loading/loading.module';
import {DialogModule} from '../../../../../common/dialog/dialog.module';
import {AccountChangeDialogComponent} from './account-change-dialog.component';
import {FormFieldModule} from '../../../../../core/component/form-field/form-field.module';
import {
    AccountingAccountSelectFilterModule
} from '../../../../../accounting/account/api/component/accounting-account-select-filter/accounting-account-select-filter.module';
import {SelectFilterModule} from '../../../../../../components/common/select-filter/select-filter.module';
import {SaleSearchModule} from '../../../../../sale/api/component/sale-search/sale-search.module';
import {SelectSearchDataModule} from '../../../../../../components/common/select-search-data/select-search-data.module';
import {SelectModule} from '../../../../../../components/common/select/select.module';
import {ButtonModule} from '../../../../../core/component/button/button.module';
import {PaginatedListDataModule} from '../../../../../core/component/paginated-list-data/paginated-list-data.module';
import {InputTextModule} from '../../../../../core/component/input-text/input-text.module';
import {ItemModule} from '../../../../../core/component/item/item.module';
import {SummaryModule} from '../../../../../core/component/summary/summary.module';
import {CardV2Component} from "../../../../../core/component/card-v2/card-v2.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        CardModule,
        LoadingModule,
        DialogModule,
        FormFieldModule,
        AccountingAccountSelectFilterModule,
        SelectFilterModule,
        SaleSearchModule,
        SelectSearchDataModule,
        SelectModule,
        ButtonModule,
        PaginatedListDataModule,
        InputTextModule,
        ItemModule,
        SummaryModule,
        CardV2Component,
    ],
    declarations: [AccountChangeDialogComponent]
})
export class AccountChangeDialogModule {
}
